import React from "react";
import JiraIssuePicker from "./JiraIssuePicker";
import ContactPicker from "./ContactPicker";
import AccountPicker from "./AccountPicker";
import type { LinkItemOption } from "./picker-shared";

// Re-export types and utilities for backward compatibility
export type { LinkItemOption } from "./picker-shared";
export { renderItemIcon, renderAvatar } from "./picker-shared";

export interface LinkItemPickerV2Props {
  onChange?: (item: LinkItemOption | null) => void;
  type: string; // "TASK" | "CONTACT" | "COMPANY" | "SALE" | "ISSUE"
  items?: any; // Immutable or plain object
  projectId: string;
  placeholder?: string;
  autoOpen?: boolean;
  className?: string;
  noBorder?: boolean;
  showBorder?: boolean; // Explicit option to show border
  maxWidth?: string; // Deprecated: use width instead
  width?: string; // Width for trigger button
  popoverMinWidth?: string; // Min width for popover content (default: 382px)
  showInfoIcon?: boolean;
  showSelectIcon?: boolean;
  hideSelectIconUntilHover?: boolean; // Hide the select icon until the parent cell is hovered
  showIcon?: boolean;
  isViewMode?: boolean;
  projectView?: string;
  customTrigger?: React.ReactNode; // Custom trigger element to replace default button
  showTriggerHeight?: boolean; // Whether to adjust PopoverContent position based on trigger height
  useInApp?: boolean;
}

const LinkItemPickerV2: React.FC<LinkItemPickerV2Props> = (props) => {
  const { type } = props;

  if (type === "TASK" || type === "ISSUE") {
    return <JiraIssuePicker {...props} type={type as "TASK" | "ISSUE"} />;
  }

  if (type === "CONTACT") {
    return <ContactPicker {...props} type="CONTACT" />;
  }

  if (type === "COMPANY") {
    return <AccountPicker {...props} type="COMPANY" />;
  }
  return <ContactPicker {...props} type="CONTACT" />;
};

export default LinkItemPickerV2;
